<template>
  <div
    class="h-screen flex justify-center theme-club6"
    :style="getBackground()"
  >
    <div
      class="flex items-center justify-center w-full p-2"
      :class="clubId !== 0?'-mt-56':'-mt-56'"
    >
      <div class="w-full max-w-lg">
        <img
          v-if="club.clubId !== 0"
          class="p-6 sm:p-12 mt-16 sm:mt-4 md:mt-0 mb-6 mr-auto ml-auto"
          style="height: 200px; width: 300px;"
          :src="currentTheme.loginLogo"
        >
        <form
          class="bg-white shadow-lg p-3 pl-4 pr-4 sm:p-4 sm:pl-5 sm:pr-5 md:p-5 md:pl-6 md:pr-5 m-auth border-t-4 border-brand-500"
          @submit.prevent="login"
        >
          <div v-if="!loading && !forgottenPassword">
            <h1 class="text-sm xxxs:text-base xs:text-lg mb-4 text-brand-500 text-center brand-heading transition-all duration-500">
              <span v-if="club.clubId === 0">Sign in to Your Account</span>
              <span
                v-else
                class="text-xl"
              >Sign in to {{ club.clubName }}</span>
            </h1>

            <div
              v-if="loginFailed"
              class="text-base text-red-700 -mt-1 mb-1"
            >
              Sorry, your email address or password was incorrect.
            </div>

            <div class="mb-4">
              <label class="block text-gray-800 text-sm mb-2 font-normal tracking-wide">Email Address</label>
              <input
                v-model="username"
                required
                type="text"
                class="shadow appearance-none border w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
              >
            </div>

            <div class="mb-6">
              <label class="block text-gray-800 text-sm mb-2 tracking-wide">Password</label>
              <input
                v-model="password"
                required
                type="password"
                class="shadow appearance-none border w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
              >
            </div>

            <div class="flex items-center justify-between text-lg ">
              <button
                class="py-1 px-3 brand-button focus:outline-none focus:shadow-outline transition-all transition-200 transition-ease-in-out"
                type="submit"
              >
                Sign In
              </button>
              <a
                class="inline-block align-baseline cursor-pointer select-none brand-button-secondary
                transition-color transition-400 transition-ease-in-out noSelect mr-0 pr-0"
                @click="forgottenPassword = true"
              >Forgot Password?</a>
            </div>
          </div>

          <div v-if="!loading && forgottenPassword">
            <h1 class="text-sm xxxs:text-base xs:text-lg mb-4 text-brand-500 text-center brand-heading ">
              <span v-if="clubId === 0">Reset Your Password</span>
              <span
                v-else
                class="text-xl"
              >Reset your password<span v-if="club.clubId !== 0"> for {{ club.clubName }}</span></span>
            </h1>

            <div v-if="!resetSent">
              <div class="mb-4">
                <label class="block text-gray-800 text-sm mb-2">Email Address</label>
                <input
                  v-model="username"
                  required
                  type="text"
                  placeholder="Email Address"
                  class="shadow appearance-none border w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                >
              </div>

              <div class="sm:flex items-baseline justify-between mt-6 sm:mt-4 text-lg">
                <div
                  class=" mb-2 text-center py-1 px-3 text-lg brand-button select-none cursor-pointer
                  focus:outline-none focus:shadow-outline transition-bg transition-200 transition-ease-in-out noSelect"
                  :class="passwordResetLoading?'text-gray-300 cursor-wait':'text-white'"
                  @click="sendPasswordReset"
                >
                  Reset password
                </div>

                <div
                  class="block text-center sm:text-right sm:inline-block align-baseline cursor-pointer select-none noSelect text-brand-500 brand-button-secondary hover:text-secondary-500 transition-bg transition-200 transition-ease-in-out"
                  @click="forgottenPassword = false"
                >
                  Back to Login
                </div>
              </div>
            </div>

            <div v-else>
              <div class="text-base text-gray-800">
                If the email address {{ username }} exists in our system, we've sent you instructions to reset your password.
              </div>

              <div class="flex items-center justify-between mt-4 text-lg">
                <div />

                <a
                  class="inline-block align-baseline cursor-pointer select-none noSelect text-brand-500 brand-button-secondary hover:text-secondary-500 transition-bg transition-200 transition-ease-in-out"
                  @click="forgottenPassword = false"
                >Back to Login</a>
              </div>
            </div>
          </div>

          <div
            v-if="loading"
            class="text-center m-5"
          >
            <LoadingSpinner />
          </div>
        </form>

        <div
          v-if="club.clubId !== 0"
          class="text-center py-2 noSelect transition-all transition-500 transition-ease-in-out cursor-pointer brand-button
          select-none text-sm sm:text-base bg-brand-500"
          @click="learnMore()"
        >
          <div>
            {{ club.loginText }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { LoginAttempt } from 'pmg-services';
import { nodeEnv } from '@/environment/environment';

import router from '../../app-routes';
import services from '@/app/shared/services';
import LoadingSpinner from '../../shared/components/base/loadingSpinner.vue';

export default {
  components: {
    LoadingSpinner,
  },

  data() {
    return {
      username: '',
      password: '',
      loading: false,
      forgottenPassword: false,
      resetSent: false,
      loginFailed: false,
      mounted: false,
      passwordResetLoading: false,
      clubId: 0,

      environment: undefined,
      bgImg: Math.floor(Math.random() * 5),
      baseUrl: process.env.VUE_APP_BASE_URL,

    };
  },

  computed: {
    ...mapState({
      userGuid: state => state.user.userGuid,
      isAuthenticated: state => state.user.isAuthenticated,
    }),

    ...mapGetters({
      currentTheme: 'getCurrentTheme',
      club: 'getClub',
    }),
  },

  watch: {
    isAuthenticated() {
      if (this.isAuthenticated && this.mounted) {
        if (this.$route.query.returnUrl !== undefined && this.environment !== 'cordova') {
          router.push(this.$route.query.returnUrl);
        } else {
          router.push('/');
        }
      }
    },
  },

  created() {
    const homeClubId = 259;

    if (homeClubId !== undefined && this.$route.params.clubId === undefined && homeClubId !== null) {
      window.location.href = `/Login/Club/${homeClubId}`;
    } else {
      this.clubId = Number(this.$route.params.clubId);
    }

    this.environment = nodeEnv;

    if (this.userGuid !== '') {
      router.push('/');
    }

    this.$store.commit('setOverridingClubId', this.clubId);
    this.mounted = true;
  },

  methods: {
    learnMore() {
      router.push(`/Club/${this.club.clubName}/${this.clubId}`);
    },

    getBackground() {
      if (this.club.clubId !== 0) {
        return `background: linear-gradient(rgba(255, 255, 255, 0.5), rgba(0, 0, 0, 0.2)), url('${this.currentTheme.coverImage}'); background-size: cover; background-position: center;`;
      }
      return `background: linear-gradient(rgba(255, 255, 255, 0.5), rgba(0, 0, 0, 0.2)), url('${process.env.VUE_APP_BASE_URL}img/login/${this.bgImg}-min.jpg'); background-size: cover; background-position: center;`;
    },

    login() {
      this.loading = true;
      services.account.login(new LoginAttempt(this.username, this.password)).then((loginResult) => {
        this.loading = false;
        if (loginResult.ValidCredentials) {
          this.$store.dispatch('setAuth', true).then(() => {
            this.$store.dispatch('populateMemberSummary');
            this.$store.dispatch('refreshBasket');
          });

          if (loginResult.UseFallbackUI) {
            // admin - go to the API url
            window.location = process.env.VUE_APP_ADMIN_URL;
          } else if (this.$route.query.returnUrl !== undefined && this.environment !== 'cordova') {
            router.push(this.$route.query.returnUrl);
          } else {
            router.push('/');
          }
        } else {
          this.loginFailed = true;
        }
      });
    },

    sendPasswordReset() {
      if (this.username !== '' && !this.passwordResetLoading) {
        this.passwordResetLoading = true;

        services.account.resetPassword(this.username, false).then(() => {
          this.resetSent = true;
          this.passwordResetLoading = false;
        });
      }
    },
  },
};
</script>
